module.exports = __webpack_public_path__ + "img/sintesis.b45a8613.png";